import { BOH_THRESHOLDS_EDIT_REQUEST, BOH_THRESHOLDS_EDIT_SUCCESS, BOH_THRESHOLDS_EDIT_FAILURE } from './types/BalanceOnHandThresholdsEditActionsTypes';

export function postBalanceOnHandThresholdsEditRequestActionCreator(context, impc, week, minThresholdVal, maxThresholdVal, id) {
  return {
    type: BOH_THRESHOLDS_EDIT_REQUEST,
    payload: {
      appContext: context,
      params: {
        impcCode: impc,
        weeks: week,
        minThreshold: minThresholdVal,
        maxThreshold: maxThresholdVal,
        id,
      },
    },
  };
}

export function postBalanceOnHandThresholdsEditSuccessActionCreator(data) {
  return {
    type: BOH_THRESHOLDS_EDIT_SUCCESS,
    payload: data,
  };
}

export function postBalanceOnHandThresholdsEditFailureActionCreator(error) {
  return {
    type: BOH_THRESHOLDS_EDIT_FAILURE,
    payload: error,
    error: true,
  };
}
